<template>
  <div class="m-flex-clounm m-sec-detail">
    <h3 class="m-form-title" style="margin-bottom: 54px">填写婚礼信息</h3>
    <div class="form-content">
      <div class="con-title flex-center">
        <div class="con-title-div">定单类型</div>
        <div style="position: relative">
          <el-select v-model="weddingOrderType" placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <img
            src="../../assets/images/open-province.png"
            class="collpose-img"
          />
        </div>
      </div>
      <div style="padding-left: 39px">
        <div class="m-form-input">
          <div class="input-label">
            <span class="input-label-name">定单联系人</span>
          </div>
          <div class="flex-center" style="position: relative">
            <template v-if="weddingOrderType === 0">
              <el-select
                v-model="weddingRoleType"
                placeholder="请选择"
                class="select-abs"
              >
                <el-option
                  v-for="item in peopleList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <img
                src="../../assets/images/open-province.png"
                class="collpose-img"
                style="right: 306px; top: 18px"
              />
            </template>
            <input
              placeholder="请输入姓名"
              v-model.trim="inputName"
              :style="{ paddingLeft: weddingOrderType === 0 ? '70px' : '0px' }"
              maxlength="10"
            />
          </div>

          <span class="m-error" ref="inputNameError"></span>
        </div>
        <div class="m-form-input">
          <div class="input-label">
            <span class="input-label-name">电话</span>
          </div>
          <input
            placeholder="请输入手机号"
            v-model.trim="inputPhone"
            type="text"
            maxlength="11"
          />
          <span class="m-error" ref="inputPhoneError"></span>
        </div>
        <div class="m-form-input m-form-img" v-if="smsNum > 10000">
          <input
            placeholder="* 图形验证码"
            v-model.trim="inputVerify"
            type="text"
            maxlength="4"
          />
          <img :src="picSrc" @click="refreshImg" />
          <span class="m-error" ref="inputVerifyError"></span>
        </div>
        <!-- <div class="m-form-input m-code-input">
          <div class="input-label">
            <span class="input-label-name">短信验证码</span>
          </div>
          <input
            placeholder="请输入验证码"
            v-model.trim="inputCode"
            maxlength="6"
            style="width: 251px"
          />
          <a
            href="javascript:void(0);"
            :class="{ 'm-none': mnone }"
            @click="beforeSend"
            >{{ countName }}</a
          >
          <span class="m-error" ref="inputCodeError"></span>
        </div> -->
        <!-- v-if="idCard" -->
        <div class="m-form-input">
          <div class="input-label">
            <span class="input-label-name"
              >身份证（用于签合同，此处请与定单联系人保持一致）</span
            >
          </div>
          <input
            placeholder="请输入身份证号码"
            v-model.trim="inputIdCard"
            maxlength="18"
          />
          <span class="m-error" ref="inputidCardError"></span>
        </div>
        <!-- <div class="name-panel">
      <div class="name-panel-block">
        <div class="m-form-input">
          <input
            placeholder="备用联系人(选填)"
            v-model.trim="inputName2"
            maxlength="10"
          />
        </div>
        <div class="m-form-input">
          <input
            placeholder="备用联系人电话(选填)"
            v-model.trim="phone2"
            maxlength="11"
          />
        </div>
      </div>
    </div> -->
        <template v-if="weddingOrderType === 0">
          <div class="m-form-input">
            <div class="input-label">
              <span class="input-label-name"
                >{{
                  weddingRoleType === "BRIDE" || weddingRoleType === "RELATIVES"
                    ? "新郎"
                    : "新娘"
                }}姓名</span
              >
              <span class="input-label-tip">(选填)</span>
            </div>
            <input
              placeholder="请输入姓名"
              v-model.trim="inputName2"
              maxlength="10"
            />
          </div>
          <div class="m-form-input">
            <div class="input-label">
              <span class="input-label-name"
                >{{
                  weddingRoleType === "BRIDE" || weddingRoleType === "RELATIVES"
                    ? "新郎"
                    : "新娘"
                }}手机号</span
              >
              <span class="input-label-tip">(选填)</span>
            </div>
            <input
              placeholder="请输入手机号"
              v-model.trim="phone2"
              maxlength="11"
            />
            <span class="m-error" ref="phone2Error"></span>
          </div>
          <!-- </template> -->
          <template v-if="weddingRoleType === 'RELATIVES'">
            <div class="m-form-input">
              <div class="input-label">
                <span class="input-label-name">新娘姓名</span>
                <span class="input-label-tip">(选填)</span>
              </div>
              <input
                placeholder="请输入姓名"
                v-model.trim="inputNameOther"
                maxlength="10"
              />
            </div>
            <div class="m-form-input">
              <div class="input-label">
                <span class="input-label-name">新娘手机号</span>
                <span class="input-label-tip">(选填)</span>
              </div>
              <input
                placeholder="请输入手机号"
                v-model.trim="phoneOther"
                maxlength="11"
              />
              <span class="m-error" ref="phoneOtherError"></span>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="m-form-input">
            <div class="input-label">
              <span class="input-label-name">备用联系人</span>
              <span class="input-label-tip">(选填)</span>
            </div>
            <input
              placeholder="请输入姓名"
              v-model.trim="inputName2"
              maxlength="10"
            />
          </div>
          <div class="m-form-input">
            <div class="input-label">
              <span class="input-label-name">备用联系人电话</span>
              <span class="input-label-tip">(选填)</span>
            </div>
            <input
              placeholder="请输入手机号"
              v-model.trim="phone2"
              maxlength="11"
            />
            <span class="m-error" ref="phone2Error"></span>
          </div>
        </template>
        <div class="m-rela">
          <div class="m-form-input">
            <div class="input-label">
              <span class="input-label-name">{{
                weddingOrderType === 0 ? "婚期" : "服务日期"
              }}</span>
              <span class="input-label-tip">(选填)</span>
            </div>
            <!-- <input placeholder="请选择婚礼时间" ref="dateInput"  v-model="inputText" @click.stop.prevent="onInputClick" readonly/> -->
            <el-date-picker
              v-model="inputText"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="服务日期"
              :picker-options="afterToday"
              clear-icon="clearDangqiNone"
              class="common-date-picker"
            ></el-date-picker>
            <span class="m-error"></span>
          </div>
          <!--用v-if控制显示跟隐藏-->
          <!-- <div class="calendar-wrapper" v-if="calendarVisible" style="width: 388px;">
        <calendar :value="calendarValue" :begin="beginValue" @select="onDatePicked"></calendar>
      </div> -->
        </div>
        <div class="m-form-input">
          <div class="input-label">
            <span class="input-label-name">举办时间</span>
          </div>
          <el-radio-group v-model="timeSlot">
            <el-radio label="1" size="large" border>午宴</el-radio>
            <el-radio label="2" size="large" border>晚宴</el-radio>
          </el-radio-group>
          <span class="m-error" ref="timeSlotError"></span>
        </div>
        <div class="m-rela">
          <div class="m-form-input">
            <div class="input-label">
              <span class="input-label-name"
                >{{ weddingOrderType === 0 ? "婚礼" : "" }}举办城市</span
              >
            </div>
            <input
              placeholder="请选择城市"
              v-model="inputCity"
              @click.stop.prevent="openCity"
              readonly
            />
            <span class="m-error" ref="cityInput"></span>
          </div>
          <div class="rela-display" v-if="cityVisible">
            <city
              :curPro="curPro"
              :curId="curId"
              :curCity="curCity"
              @getCity="getCitySelf"
            ></city>
          </div>
        </div>
        <div class="" style="margin-top: 36px">
          <div class="m-form-input">
            <div class="input-label">
              <span class="input-label-name">通讯地址</span>
              <span class="input-label-tip">(用于签署定金合同)</span>
            </div>
            <div class="address-content">
              <el-cascader
                placeholder="省份/城市/区县"
                v-model="postalProvinceAndCity"
                :options="areaList"
                :props="areaProps"
                @change="cityChange"
                filterable
                class="address-cascader"
                style="width: 370px"
              >
              </el-cascader>
              <input
                placeholder="请输入地址"
                style="min-width: 370px; margin-left: 20px"
                maxlength="50"
                v-model="postalAddress"
              />
            </div>
            <span class="m-error" ref="postalAddress"></span>
          </div>
        </div>
      </div>
      <div class="btn-content">
        <div class="primary-btn" v-if="!isLoading" @click="getFormSubmit">
          立即预定
        </div>
        <div class="primary-btn" v-else>提交中...</div>
      </div>
    </div>
    <template v-if="weddingOrderType === 0">
      <div class="recog-fixed">
        <div class="recog-start" @click="setRecogInfo">
          <img
            :class="[
              'recog-img',
              showRegInfo === 1 ? 'rolateLeft' : '',
              showRegInfo === 2 ? 'rolateRight' : '',
            ]"
            src="../../assets/images/recog-left.png"
          />
          <div>文字</div>
          <div>识别</div>
        </div>
        <template>
          <div
            :class="[
              'recog-content ',
              showRegInfo === 1 ? 'slideInRight' : '',
              showRegInfo === 2 ? 'slideInLeft' : '',
            ]"
          >
            <div class="flex-center">
              <img
                class="recog-img"
                src="../../assets/images/recog-right.png"
              />
              <div class="recog-title">定单文字识别</div>
              <div class="copy-btn" @click="copyInfo">复制模版</div>
            </div>
            <div class="textarea-div">
              <el-input
                type="textarea"
                :placeholder="importContentSample"
                v-model="contentRule"
              ></el-input>
            </div>
            <div>
              <a
                :class="[
                  'recog-btn',
                  contentRule && contentRule.length > 0 ? '' : 'disabled',
                ]"
                @click="recogAllInfo"
                >识别</a
              >
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import dayjs from "dayjs";
import api from "../../config/api.js";
import { verificationCode } from "../../plugin/verificationCode";
import calendar from "../common/calendar.vue";
import city from "../common/select-city.vue";
export default {
  name: "fill-form",
  components: { calendar, city },
  props: ["allData"],
  data: function () {
    return {
      areaProps: {
        value: "id",
        label: "name",
        children: "childList",
      },
      typeList: [
        { value: 0, label: "婚庆定单" },
        { value: 1, label: "非婚庆定单" },
      ],
      weddingOrderType: 0,
      peopleList: [
        { value: "BRIDE", label: "新娘" },
        { value: "BRIDEGROOM", label: "新郎" },
        { value: "RELATIVES", label: "亲属" },
      ],
      weddingRoleType: "BRIDE",
      // relationType: "1", // 1 新娘 2 新郎 3亲属
      importContentSample:
        "新郎名字/电话:测试 18311339909 \n新娘名字/电话:测试 18311339909 \n身份证号码（订单人）:510125199401140041\n地址（通讯地址合同用）:四川省成都市高新区益州大道8999号",
      contentRule: "",
      areaList: [],
      postalProvinceAndCity: [],
      inputText: "",
      isLoading: false,
      inputPhone: "",
      mnone: false,
      inputCode: "",
      inputVerify: "",
      inputName: "",
      inputName2: "",
      inputNameOther: "", // 新增的名字
      phone2: "",
      phoneOther: "", // 新增的电话号码
      inputIdCard: "", //身份证号码
      agentData: [],
      agentId: "",
      idCard: "",
      // emptyBtn:false,
      smsNum: 0,
      countTime: 60,
      countName: "点击获取",
      picSrc: api.API_URL + "sms/v1/code/image",
      picUrl: api.IMAGE_URL,
      firData: this.allData,
      comButton: true, //控制提交
      calendarVisible: false, //控制日历框是显示还是隐藏
      cityVisible: false, //控制选城市 显示还是隐藏
      curPro: "",
      curCity: "",
      curId: "",
      agentPro: "",
      postalAddress: "",
      afterToday: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      showRegInfo: "",
      brokerType: 0,
      timeSlot: null,
    };
  },

  watch: {
    //随时监控
    inputPhone: function (newValue) {
      //手机号
      //this.inputPhone=newValue.toString().replace(/\D/g,'');//替换成正整数;
      if (!newValue || (newValue && this.checkPhone(newValue))) {
        //正确
        this.$refs.inputPhoneError.textContent = "";
      } else {
        //错误
        this.$refs.inputPhoneError.textContent = "请输入正确的手机号";
      }
    },
    //随时监控
    phoneOther: function (newValue) {
      //手机号
      //this.inputPhone=newValue.toString().replace(/\D/g,'');//替换成正整数;
      if (!newValue || (newValue && this.checkPhone(newValue))) {
        //正确
        this.$refs.phoneOtherError.textContent = "";
      } else {
        //错误
        this.$refs.phoneOtherError.textContent = "请输入正确的手机号";
      }
    },
    phone2: function (newValue) {
      //手机号
      //this.inputPhone=newValue.toString().replace(/\D/g,'');//替换成正整数;
      if (!newValue || (newValue && this.checkPhone(newValue))) {
        //正确
        this.$refs.phone2Error.textContent = "";
      } else {
        //错误
        this.$refs.phone2Error.textContent = "请输入正确的手机号";
      }
    },
    inputName: function (newValue) {
      //名字
      if (!newValue || (newValue && this.checkName(newValue))) {
        //正确
        this.$refs.inputNameError.textContent = "";
      } else {
        //错误
        this.$refs.inputNameError.textContent = "姓名只能是2-10位的中文或英文";
      }
    },
    /**
     * 身份证号
     */
    inputIdCard: function (newValue) {
      //名字
      if (!newValue || (newValue && this.checkIdCard(newValue))) {
        //正确
        this.$refs.inputidCardError.textContent = "";
      } else {
        //错误
        this.$refs.inputidCardError.textContent =
          "请填写正确的身份证号码（注意：英文字母需要大写）";
      }
    },
    inputCode: function (newValue) {
      //验证短信验证码
      if (!newValue || (newValue && this.checkCode(newValue))) {
        //正确
        this.$refs.inputCodeError.textContent = "";
      } else {
        //错误
        this.$refs.inputCodeError.textContent = "验证码错误";
      }
    },
    // inputText:function (newValue) {
    //   if(newValue){
    //     this.emptyBtn = true;
    //   }else{
    //     this.emptyBtn = false;
    //   }
    // }
  },

  created: function () {
    this.getAreaList();
    let vm = this;
    //vm.getAgentInfo();//获取经纪人信息
    //vm.getSmsNum();//获取发送数量
    //关闭弹出框
    vm.bus.$on("closePickData", function (obj) {
      vm.calendarVisible = obj;
      vm.cityVisible = obj;
    });
    //判断是否存在数据
    if (vm.firData && vm.firData.length > 1) {
      vm.inputCode = "";
      let tempData = vm.firData[1];
      console.log("tempData", tempData);
      if (tempData.phone) {
        vm.inputPhone = tempData.phone;
      }
      if (tempData.name) {
        vm.inputName = tempData.name;
      }
      if (tempData.brokerId) {
        vm.agentId = tempData.brokerId;
        vm.agentPro = tempData.agentPro;
        vm.idCard = tempData.idCard;
        vm.brokerType = tempData.brokerType || 0;
      }
      if (tempData.curId) {
        vm.curPro = tempData.curPro;
        vm.curCity = tempData.curCity;
        vm.curId = tempData.curId;
      }
      if (tempData.weddingDate && tempData.weddingDate != "未定") {
        vm.inputText = dayjs(new Date(tempData.weddingDate)).format(
          "YYYY-MM-DD"
        );
      }
    }
  },
  computed: {
    calendarValue: function () {
      //方法是初始化日历框时间
      let m = dayjs(this.inputText || new Date());
      let arr = [m.year(), m.month() + 1, m.date()];
      return arr;
    },
    beginValue: function () {
      let m = dayjs(new Date());
      let arr = [m.year(), m.month() + 1, m.date()];
      return arr;
    },
    inputCity: function () {
      return this.curPro + this.curCity;
    },
  },
  methods: {
    copyInfoToBoard(data) {
      let oInput = document.createElement("textarea");
      oInput.value = data;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
    copyInfo() {
      let data =
        "新郎名字/电话：新郎名 新郎电话" +
        "\r\n" +
        "新娘名字/电话：新娘名 新娘电话" +
        "\r\n" +
        "身份证号码（订单人）：" +
        "\r\n" +
        "地址(通讯地址合同用)：" +
        "\r\n" +
        "——" +
        "\r\n" +
        "(tip：烦请严格按照以上格式填写“冒号”之后的内容哦）";
      this.copyInfoToBoard(data);
    },
    setRecogInfo() {
      if (!this.showRegInfo) {
        this.showRegInfo = 1;
      } else {
        this.showRegInfo = this.showRegInfo === 1 ? 2 : 1;
      }
      this.contentRule = "";
    },
    cityChange() {
      console.log("cityChange", this.postalProvinceAndCity);
    },
    getAreaList() {
      let vm = this;
      let url = api.API_URL + "/province/v1/query/area/list";
      vm.getAjax(
        url,
        "",
        function (result) {
          if (result.rcode == "000000" && result.rdata) {
            // vm.listInfo = vm.exchangeData(result.rdata); //所有城市信息
            // if(vm.selectCityId && vm.selectCityId!=''){
            //   for(let i =0;i<vm.listInfo.length;i++){
            //       if(vm.listInfo[i].province == vm.selectPro){ //
            //           vm.listCity = vm.listInfo[i].citys;
            //           break;
            //       }
            //   }
            // }else{
            //   vm.listCity = vm.listInfo[0].citys;
            // }
            vm.areaList = result.rdata;
            vm.calcAreaList();
          }
        },
        function () {}
      );
    },
    //去掉城市第三级
    calcAreaList() {
      if (this.areaList && this.areaList.length) {
        this.areaList.forEach((province) => {
          if (province.childList) {
            province.childList.forEach((city) => {
              // if (province.name == '重庆市' || province.name == '北京市' || province.name == '天津市' || province.name == '上海市') {
              //   delete city.childList
              // }
              if (!city.childList || city.childList.length == 0) {
                delete city.childList;
              }
            });
          }
        });
      }
    },
    openCity: function () {
      this.cityVisible = !this.cityVisible;
      this.calendarVisible = false; //关闭日期选择
    },
    getCitySelf: function (opt) {
      console.log("------opt", opt);
      this.cityVisible = false; //获取当前对象 以及ID
      if (opt.selectCityId && opt.selectCityId != undefined && opt.selectPro) {
        this.curPro = opt.selectPro;
        this.curCity = opt.selectCity;
        this.curId = opt.selectCityId;
        this.$refs.cityInput.textContent = "";
      }
    },
    getAgentInfo: function () {
      //获取经纪人信息
      let vm = this;
      let url = api.API_URL + "wedding/broker/v1/list";
      vm.getAjax(
        url,
        "",
        function (result) {
          if (result.rcode == "000000" && result.rdata) {
            vm.agentData = result.rdata;
            vm.agentId = result.rdata[0].id;
          }
        },
        function () {}
      );
    },
    getAgentId: function (agid) {
      this.agentId = agid;
    },
    getSmsNum: function () {
      //获取发送的数量 防止刷
      //获取经纪人信息
      let vm = this;
      let url = api.API_URL + "sms/v1/code/num";
      vm.getAjax(
        url,
        "",
        function (result) {
          if (result.rcode == "000000" && result.rdata) {
            vm.smsNum = result.rdata;
          }
        },
        function () {}
      );
    },
    refreshImg: function () {
      //获取图形验证码
      this.picSrc = this.picSrc + "?fresh=" + new Date().getTime();
    },
    onInputClick: function () {
      this.calendarVisible = !this.calendarVisible;
      this.cityVisible = false; //关闭城市选择
    },
    onDatePicked: function (val) {
      //alert(JSON.stringify(val));
      this.inputText = dayjs(
        val[0] +
          "-" +
          (val[1] <= 9 ? "0" : "") +
          val[1] +
          "-" +
          (val[2] <= 9 ? "0" : "") +
          val[2]
      ).format("YYYY-MM-DD");
      this.calendarVisible = false;
    },
    beforeSend: function () {
      if (this.mnone) return;
      let vm = this;
      if (!vm.checkPhone(vm.inputPhone)) {
        //手机号失败
        this.$refs.inputPhoneError.textContent = "请输入正确的手机号";
        return;
      }
      verificationCode(vm.getSmsCode);
    },
    getSmsCode: function (randstr = "", ticket = "") {
      if (this.mnone) return;
      //获取短信验证码
      let vm = this;
      if (vm.countTime == 60) {
        let params = { phone: vm.inputPhone, serviceId: vm.firData[0]["serviceId"] };
        if (randstr.length && ticket.length)
          params = { ...params, randstr, ticket };
        //获取短信验证码
        let url = api.API_URL + "sms/v1/send/sms/captcha/zwPcCheckEchoey";
        vm.getAjax(
          url,
          params,
          function (result) {
            if (result.rcode == "000000") {
              vm.$refs.inputCodeError.textContent = "短信发送成功";
              vm.countDown();
              vm.mnone = true;
            } else {
              //失败
              vm.$refs.inputCodeError.textContent =
                "短信发送失败，" + result.rdesc;
            }
          },
          function () {}
        );
      }
    },
    countDown: function () {
      let vm = this;
      let timeout = null;
      if (vm.countTime <= 0) {
        vm.countTime = 60;
        vm.countName = "点击获取";
        vm.mnone = false;
        if (!timeout) {
          clearTimeout(timeout);
        }
      } else {
        vm.mnone = true;
        vm.countName = vm.countTime + "s后获取";
        vm.countTime -= 1;
        timeout = setTimeout(vm.countDown, 1000);
      }
    },
    getFormSubmit: function () {
      //提交表单
      let vm = this;
      if (vm.comButton) {
        if (!vm.checkName(vm.inputName)) {
          //名字失败
          vm.$refs.inputNameError.textContent = "姓名只能是2-10位的中文或英文";
          return;
        }
        if (!vm.checkPhone(vm.inputPhone)) {
          //手机号失败
          vm.$refs.inputPhoneError.textContent = "请输入正确的手机号";
          return;
        }

        if (vm.phone2 && !vm.checkPhone(vm.phone2)) {
          //备用联系人手机号失败
          vm.$refs.phone2Error.textContent = "请输入正确的手机号";
          return;
        }
        if (vm.phoneOther && !vm.checkPhone(vm.phoneOther)) {
          //备用联系人手机号失败
          vm.$refs.phoneOtherError.textContent = "请输入正确的手机号";
          return;
        }
        /* 关闭验证码功能 */
        //if (!vm.checkCode(vm.inputCode)) {
        //  //短信验证码失败
        //  vm.$refs.inputCodeError.textContent = "请输入6位的短信验证码";
        //  return;
        //}
        /**
         * 身份证号未填
         */
        /*if ( vm.idCard ) {*/
        if (!vm.checkIdCard(vm.inputIdCard)) {
          //名字失败
          vm.$refs.inputidCardError.textContent =
            "您输入的身份证号不正确（注意：英文字母需要大写）";
          return;
        }
        /*}*/
        if (!vm.timeSlot) {
          vm.$refs.timeSlotError.textContent = "请选择婚礼举办时间段";
          return;
        }
        if (!vm.curId) {
          vm.$refs.cityInput.textContent = "请选择婚礼举办城市";
          return;
        }
        if (
          vm.postalAddress.trim() === "" ||
          !this.postalProvinceAndCity ||
          !this.postalProvinceAndCity.length
        ) {
          vm.$refs.postalAddress.textContent = "请填写通讯地址";
          return;
        } else {
          vm.$refs.postalAddress.textContent = "";
        }
        vm.comButton = false; //首先设置为false
        let _value =
          document.getElementsByClassName("address-cascader")[0].firstChild
            .childNodes[1].value;
        let url = api.API_URL + "order/v1/create";
        let fullCityName = _value.replace(" / ", "").replace(" / ", "");
        let ajdata = {
          cityId: vm.curId,
          name: vm.inputName,
          phone: vm.inputPhone,
          idCard: vm.inputIdCard,
          weddingDate: vm.inputText,
          // verifyCode: vm.inputCode,
          brokerId: vm.agentId,
          serviceId: vm.firData[0]["serviceId"],
          weddingRoleType:
            vm.weddingOrderType === 0 ? vm.weddingRoleType : "BRIDE", // 角色类型
          weddingOrderType: vm.weddingOrderType, // 订单类型
          addressCityId: vm.postalProvinceAndCity[1],
          addressZoneId: vm.postalProvinceAndCity[2] || "",
          addressZoneName: _value.split("/")[2]
            ? _value.split("/")[2].trim()
            : "",
          userAddress: vm.postalAddress,
          address: fullCityName + vm.postalAddress,
          phone1: "",
          name1: "",
          phone2: "",
          name2: "",
          type: vm.timeSlot == 1 ? "Luncheon" : "Dinner", // 举办时间段
        };
        // 角色新娘
        if (vm.weddingRoleType === "BRIDE") {
          ajdata.phone1 = vm.phone2;
          ajdata.name1 = vm.inputName2;
          ajdata.phone2 = vm.inputPhone;
          ajdata.name2 = vm.inputName;
        }
        // 角色新郎
        if (vm.weddingRoleType === "BRIDEGROOM") {
          ajdata.phone2 = vm.phone2;
          ajdata.name2 = vm.inputName2;
          ajdata.phone1 = vm.inputPhone;
          ajdata.name1 = vm.inputName;
        }
        // 角色亲属
        if (vm.weddingRoleType === "RELATIVES") {
          ajdata.phone1 = vm.phone2;
          ajdata.name1 = vm.inputName2;
          ajdata.phone2 = vm.phoneOther;
          ajdata.name2 = vm.inputNameOther;
        }
        vm.isLoading = true;
        vm.getAjax(
          url,
          ajdata,
          function (result) {
            vm.isLoading = false;
            //成功
            if (result.rcode == "000000") {
              console.log("----------支付跳转问题定位-1", result.rdata);
              vm.$emit("changeChannelType", result.rdata.channelType || 0);
              let obj = { cuindex: 2, menuIndex: 3 }; //2是暂停在当前页面
              vm.bus.$emit("updateIndex", obj);
              //弹出框 确定是否支付
              ajdata = result.rdata;
              ajdata["agentPro"] = vm.agentPro;
              ajdata["curPro"] = vm.curPro;
              ajdata["curCity"] = vm.curCity;
              ajdata["curType"] = result.rdata.channelType;
              vm.bus.$emit("updateData", ajdata);
              vm.bus.$emit("comBox", 1); //弹出框框
              //添加历史记录
              window.history.pushState("", null, "");
            } else {
              // bug: inputCodeError已停用 所以此处报错。修改为toast提示方式避免页面报错
              // vm.$refs.inputCodeError.textContent = result.rdesc;
              vm.$message.error(result.rdesc);
            }
            vm.comButton = true;
            return;
          },
          function () {
            vm.isLoading = false;
            // vm.$refs.inputCodeError.textContent = "网络连接异常，请稍后重试";
            vm.$message.error("网络连接异常，请稍后重试");
            vm.comButton = true;
          }
        );
      }
    },
    recogAllInfo() {
      if (!this.contentRule) return;
      // 正则表达式识别 通过换行符 格式化
      let ruleInfo = this.contentRule.split("\n");
      const namePattern = /[a-zA-Z\s]+|[\u4e00-\u9fa5]+/;
      const phonePattern = /1[123456789]\d{9}/;
      ruleInfo.forEach((item) => {
        console.log(item);
        let dataInfo = item.split(":");
        if (item.indexOf(":") < 0) {
          dataInfo = item.split("：");
        }
        if (dataInfo.length > 0) {
          let phoneInfo = (dataInfo[1] || dataInfo[0]).match(phonePattern);
          let nameInfo = (dataInfo[1] || dataInfo[0]).match(namePattern);
          console.log(dataInfo);
          if (item.indexOf("新郎") > -1) {
            if (this.weddingRoleType === "BRIDEGROOM") {
              this.inputName = (nameInfo && nameInfo[0]) || this.inputName;
              this.inputPhone = (phoneInfo && phoneInfo[0]) || this.inputName;
            } else {
              this.inputName2 = (nameInfo && nameInfo[0]) || this.inputName2;
              this.phone2 = (phoneInfo && phoneInfo[0]) || this.phone2;
            }
          } else if (item.indexOf("新娘") > -1) {
            // 看当前类型是不是新娘 不是新娘填充到新娘，是的话填充到的第一行
            if (this.weddingRoleType === "BRIDE") {
              this.inputName = (nameInfo && nameInfo[0]) || this.inputName;
              this.inputPhone = (phoneInfo && phoneInfo[0]) || this.inputPhone;
            } else if (this.weddingRoleType === "BRIDEGROOM") {
              this.inputName2 = (nameInfo && nameInfo[0]) || this.inputName2;
              this.phone2 = (phoneInfo && phoneInfo[0]) || this.phone2;
            } else {
              this.phoneOther = (phoneInfo && phoneInfo[0]) || this.phoneOther;
              this.inputNameOther =
                (nameInfo && nameInfo[0]) || this.inputNameOther;
            }
            console.log(item.match(phonePattern));
            console.log(item.match(namePattern));
          } else if (item.indexOf("身份证") > -1) {
            const regex =
              /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
            console.log(dataInfo[1].match(regex));
            this.inputIdCard =
              (dataInfo.length > 1
                ? dataInfo[1].match(regex)[0]
                : dataInfo[0].match(regex)[0]) || this.inputIdCard;
          } else if (item.indexOf("地址") > -1) {
            this.postalAddress =
              dataInfo.length > 1 ? dataInfo[1] : dataInfo[0];
            //  let reg =
            //   "(?<province>[^省]+自治区|.*?省|.*?行政区|.*?市)(?<city>[^市]+自治州|.*?地区|.*?行政单位|.+盟|市辖区|.*?市|.*?县)(?<county>[^县]+县|.+区|.+市|.+旗|.+海域|.+岛)?(?<town>[^区]+区|.+镇)?(?<village>.*)";
            let reg =
              "(?<province>[^省]+自治区|.*?省|.*?行政区|.*?市)(?<city>[^市]+自治州|.*?地区|.*?行政单位|.+盟|市辖区|.*?市|.*?县)(?<county>[^县]+县|.+区|.+市|.+旗|.+海域|.+岛)?(?<town>[^区]+区|.+镇)?(?<village>.*)";
            let refAddr = this.postalAddress.match(reg);
            console.log(refAddr);
            if (refAddr) {
              let tempCity = [];
              refAddr[1] && tempCity.push(refAddr[1]);
              refAddr[2] && tempCity.push(refAddr[2]);
              refAddr[3] && tempCity.push(refAddr[3]);
              if (tempCity.length > 1) {
                this.areaList.forEach((info) => {
                  if (info.name.indexOf(tempCity[0]) > -1) {
                    this.postalProvinceAndCity = [];
                    this.postalProvinceAndCity.push(info.id);
                    info.childList &&
                      info.childList.forEach((child) => {
                        if (child.name.indexOf(tempCity[1]) > -1) {
                          this.postalProvinceAndCity.push(child.id);
                          tempCity[2] &&
                            child.childList &&
                            child.childList.forEach((last) => {
                              if (last.name.indexOf(tempCity[2]) > -1)
                                this.postalProvinceAndCity.push(last.id);
                            });
                        }
                      });
                  }
                });
              }
            }
          }
        }
      });
      this.setRecogInfo();
    },
  },
};
</script>
<style lang="scss" scoped>
.m-form-input .m-all-btn.m-all-btn-back {
  background-color: #d8d8d8;
}
.m-sec-detail {
  margin: 0 auto !important;
  margin-top: 93px !important;
  text-align: left !important;
  padding-top: 0px !important;
  width: 840px !important;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.m-form-title {
  width: 100%;
}
.btn-content {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 48px;
}
.m-sec-detail .m-form-img * {
  vertical-align: middle;
}
.m-sec-detail .m-form-img input {
  width: 320px;
  margin-right: 30px;
}
.m-sec-detail .m-form-img img {
  width: 75px;
  height: 40px;
}
.m-form-input .emptyDiv {
  display: block;
  cursor: pointer;
  position: absolute;
  width: 17px;
  height: 17px;
  right: 10px;
  top: 42px;

  background-image: url("../../assets/images/lrdelete.png");
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.name-panel-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 432px;
  margin: 0 auto;
}
.name-panel-block .m-form-input {
  width: 200px;
  margin: 0;
}
.name-panel-block .m-form-input input {
  width: 200px;
}
.rela-display {
  position: relative;
  width: 432px;
  margin: 0 auto;
}
.form-content {
  width: 841px;
  padding-bottom: 40px;
  border-radius: 8px;
  border: 1px solid #efefef;
  .con-title {
    height: 56px;
    margin-bottom: 24px;
    background: #f6f8fa;
  }
  .con-title-div {
    margin-left: 28px;
    margin-right: 24px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.9);
    line-height: 22px;
  }
  .collpose-img {
    width: 12px;
    height: 13px;
    top: 13px;
    right: 17px;
    position: absolute;
  }
  .m-form-input {
    width: 370px;
    margin-right: 20px;
    input {
      width: 370px;
    }
  }
}
.m-body .m-rela {
  width: 370px !important;
  margin-right: 20px;
}
.recog-fixed {
  position: fixed;
  right: 11px;
  bottom: 80px;
  height: 293px;
  z-index: 999;
}
.recog-start {
  margin-left: 276px;
  margin-bottom: 10px;
  background: #ffffff;
  padding: 6px 0px 14px;
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 36px;
  cursor: pointer;
  text-align: center;

  div {
    font-size: 12px;
    color: rgba(71, 71, 71, 0.9);
    line-height: 17px;
    &:first-child {
      margin-top: 8px;
    }
  }
}
.recog-content {
  background: #ffffff;
  padding: 6px 12px 12px;
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  opacity: 0;
  .recog-title {
    margin-left: 8px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(71, 71, 71, 0.9);
    line-height: 17px;
  }
  .textarea-div {
    position: relative;
    margin: 6px 0px 8px;
  }
  .recog-btn {
    display: block;
    margin: 0 auto;
    width: 54px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #a28b77;
    border-radius: 6px;
    color: #ffffff;
    font-size: 15px;
    &.disabled {
      opacity: 0.4;
    }
  }
}
.recog-img {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.slideInRight {
  animation: slideInRight 1s ease-in-out;
  -webkit-animation: slideInRight 1s ease-in-out;
  opacity: 1;
}
@keyframes slideInRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}
@-webkit-keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
}
.slideInLeft {
  animation: slideInLeft 1s ease-in-out;
  -webkit-animation: slideInLeft 1s ease-in-out;
  opacity: 0;
}
@keyframes slideInLeft {
  0% {
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
}
@-webkit-keyframes slideInLeft {
  0% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(100%);
    opacity: 0;
  }
}
.rolateLeft {
  animation: rolateLeft 1s ease forwards;
  -webkit-animation: rolateLeft 1s ease forwards;
}
@keyframes rolateLeft {
  0% {
    transform: rotateY(0);
  }
  100% {
    transform: rotateY(180deg);
  }
}
@-webkit-keyframes rolateLeft {
  0% {
    -webkit-transform: rotateY(0);
  }
  100% {
    -webkit-transform: rotateY(180deg);
  }
}
.rolateRight {
  animation: rolateRight 1s ease forwards;
  -webkit-animation: rolateRight 1s ease forwards;
}
@keyframes rolateRight {
  0% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(0);
  }
}
@-webkit-keyframes rolateRight {
  0% {
    -webkit-transform: rotateY(180deg);
  }
  100% {
    -webkit-transform: rotateY(0);
  }
}
</style>

<style lang="scss">
.recog-content .el-textarea__inner {
  background: #ffffff;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #efefef;
  height: 118px;
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.9);
  width: 288px;
  &::placeholder {
    color: #c0c4d4;
    font-size: 12px;
  }
}
.el-date-table td.current:not(.disabled) span {
  background-color: #a28b77;
}
.el-date-table td.today span {
  color: #a28b77;
}
.common-date-picker .el-input__inner {
  padding-left: 26px;
  padding-right: 0px;
}
.common-date-picker .el-input__prefix {
  width: 18px;
  height: 18px;
  left: 14px;
  top: 15px;
  background: url("../../assets/images/date-icon.png") no-repeat;
  background-size: 18px 18px;
  /* display: none; */
}
.common-date-picker .el-input__prefix i {
  display: none !important;
}
.common-date-picker .el-input__suffix {
  display: none;
}
.form-content .el-select .el-input .el-input__inner,
.form-content .el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #ebebeb;
  background: rgba(255, 255, 255, 0);
  color: rgba(71, 71, 71, 0.9);
  font-size: 13px;
  width: 188px;
}
.form-content .el-select .el-input .el-input__suffix {
  display: none !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(251, 247, 244, 0.9);
}

.form-content .m-form-input .el-input__inner {
  width: 370px !important;
}
.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #a28b77;
}
.form-content .select-abs {
  position: absolute;
  left: 0px;
  top: 0px;
  .el-input .el-input__inner {
    width: 80px !important;
    border: none;
    text-align: left;
    text-indent: 0px;
  }
}
.form-content .select-abs.el-select .el-input.is-focus .el-input__inner {
  border: none;
}
.copy-btn {
  color: #a28b77;
  font-size: 16px;
  cursor: pointer;
  margin-left: 119px;
}
</style>



// WEBPACK FOOTER //
// fill-form.vue?0c288452